import React from 'react';

const Banner = () => {

    return (
        <div className="hero h-72 lg:min-h-screen " style={{ backgroundImage: `url("https://freerangestock.com/sample/140599/pizzas-on-dark-taple-top-background--with-copyspace.jpg")` }}>
            <div className="hero-content text-center text-indigo-50 backdrop-blur-lg">
                <div className="max-w max-w-md">
                    <h1 className="mb-5 text-3xl lg:text-5xl font-extrabold">Best Homemade Kitchen</h1>
                    <p className="text-3xl mb-5 font-extrabold">In Town</p>
                </div>
            </div>
        </div>
    );
};

export default Banner;